import { setCSSCustomProperty } from '../helpers/css';
import { Autoplay } from 'swiper/modules';
import { EffectFade } from 'swiper/modules';
import { Thumbs } from 'swiper/modules';
import { Navigation } from 'swiper/modules';
import { CountUp } from 'countup.js';
import wait from '../helpers/wait';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';
import 'swiper/css/navigation';
import Chart from 'chart.js/auto';

import { Pagination } from 'swiper/modules';
import 'swiper/css/navigation';

const isPage = (slug) => document.body.classList.contains(slug);

export const UIController = {
  init() {
    return new Promise((resolve, reject) => {
      try {
        this.initMeasurementCheckers();
        this.recordNavBarHeight();
        if (isPage('home')) {
          this.initHeroSwiper();
          // this.initScrollIntoView();
          this.initMeasurementCheckersHome();
          this.initThemeOverlay();
          this.initOverlayScroll();
          // this.initVideoSlideWatchers();
        } else {
          // this.createMemberClubsDoughnutChart();
          this.initImageContentSwipers();
          this.initProgressBar();
          this.initBoxImageGalleryBlockSwipers();
          this.initImageGalleryBlockSwipers();
          this.initBoxSlideBlockSwipers();
          this.initBoxSlideGalleryBlockSwipers();
          this.initCountUp();
          this.initPageTopicsPanel();
          this.initPageTopicsMenu();
          this.initPageScrollIntoView(); // this needs to come last
        }
        // if (isPage('single') || isPage('page-template-page')) {
        // }
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },

  initPageTopicsMenu() {
    const navPagesSwiper = document.querySelector('.nav-pages-swiper');

    if (navPagesSwiper) {
      new Swiper(navPagesSwiper, {
        loop: false,
        modules: [Navigation],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        },
      });
    }

    const targetElements = document.querySelectorAll(
      '.section-page-content .container > .guttenberg-content h2'
    );

    const triggerElementsWrapper = document.querySelector(
      '.page-content__nav-pages-navigation .swiper-wrapper'
    );

    const navEl = document.getElementById('site-nav');
    const navHeight = navEl ? navEl.clientHeight : 0;

    const headerEl = document.querySelector('.section-header');
    const headerHeight = headerEl ? headerEl.clientHeight : 0;

    const wpBar = document.getElementById('wpadminbar');
    const wpBarHeight = wpBar ? wpBar.clientHeight : 0;

    if (targetElements) {
      let i = 0;
      Array.from(targetElements).forEach((el) => {
        el.classList.add('scrollToElementTarget');
        el.classList.add('scrollToElementTarget' + i);
        const targetElementContent = el.textContent;
        if (triggerElementsWrapper) {
          const triggerChildElWrapper = document.createElement('div');
          triggerChildElWrapper.classList.add('swiper-slide');
          const triggerChildEl = document.createElement('a');
          triggerChildElWrapper.append(triggerChildEl);
          triggerChildEl.classList.add('scrollToMenuElementButtonTrigger');
          triggerChildEl.classList.add('caption');
          triggerChildEl.append(targetElementContent);
          triggerElementsWrapper.appendChild(triggerChildElWrapper);
        }
        i++;
      });

      document
        .querySelectorAll('.scrollToMenuElementButtonTrigger')
        .forEach((el) => {
          el.addEventListener('click', () => {
            // Removes the 'is-focused' class from all slides
            document
              .querySelectorAll('.swiper-slide.is-focused')
              .forEach((focusedSlide) => {
                focusedSlide.classList.remove('is-focused');
              });

            // Adds class to clicked slide
            const slide = el.closest('.swiper-slide');
            if (slide) {
              slide.classList.add('is-focused');
            }
          });
        });

      const triggerElements = document.querySelectorAll(
        '.scrollToMenuElementButtonTrigger'
      );
      i = 0;
      Array.from(triggerElements).forEach((el) => {
        el.classList.add('scrollToMenuElementButtonTrigger' + i);
        if (el.classList.contains(`scrollToMenuElementButtonTrigger${i}`)) {
          const targetElem = document.querySelector(
            `.scrollToElementTarget${i}`
          );
          const targetElementOffset = targetElem ? targetElem.offsetTop : 0;

          const nav = document.querySelector('nav');

          const navPages = document.querySelector(
            '.page-content__nav-pages-wrapper'
          );

          const navPagesHeight = navPages ? navPages.clientHeight : 0;

          const navHeight = nav ? nav.clientHeight : 0;
          const wpBarHeight = wpBar ? wpBar.offsetHeight : 32;

          el.addEventListener('click', () => {
            window.scrollTo({
              top:
                targetElementOffset +
                headerHeight -
                navHeight -
                wpBarHeight -
                navPagesHeight,
              behavior: 'smooth',
            });
          });
        }
        i++;
      });
    }
  },

  createMemberClubsDoughnutChart(legendPosition) {
    Chart.defaults.color = '#002D5F';

    var ctx = document.getElementById('MemberClubsDoughnutChart');

    const fontSpec = {
      family: 'futura-pt, Avenir, Montserrat, sans-serif',
      size: 16,
      style: 'normal',
      lineHeight: 1.5,
      weight: 400,
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      cutout: '75%',
      plugins: {
        legend: {
          position: legendPosition,
          display: true,
          labels: {
            font: fontSpec,
          },
          // padding: 48,
        },
        tooltip: {
          bodyFont: fontSpec,
          titleFont: fontSpec,
        },
      },
      // layout: {
      //   padding: 96,
      // }
    };

    const data = {
      labels: [
        '74 Sport Member Clubs',
        '73 ACN (Sport-Mobility)',
        '9 International/national associations and others',
        '86 Mobility Member Clubs',
      ],
      datasets: [
        {
          data: [74, 73, 9, 86],
          backgroundColor: [
            '#002D5F',
            // '#B49664',
            'rgba(0,45,97,0.5)',
            '#BEBEBE',
            '#00B4E1',
          ],
          borderColor: 'rgba(0,0,0,0)',
        },
      ],
    };
    const config = {
      type: 'doughnut',
      data: data,
      options: options,
    };

    return new Chart(ctx, config);
  },

  updateChartLegendPosition() {
    const windowWidth = window.innerWidth;
    let legendPosition = 'top'; // Default position

    if (windowWidth < 640) {
      legendPosition = 'bottom';
      // } else if (windowWidth < 900) {
      //     legendPosition = 'left';
    } else {
      legendPosition = 'right';
    }

    // Destroy the previous chart instance if it exists
    if (window.myChart) {
      window.myChart.destroy();
    }

    // Create a new chart instance with the updated legend position
    window.myChart = this.createMemberClubsDoughnutChart(legendPosition);
  },

  initCountUp() {
    const figureElements = document.querySelectorAll('.box-item__figure');
    Array.from(figureElements).forEach((figureEl) => {
      const dataFigure = figureEl.getAttribute('data-figure');
      new CountUp(figureEl, dataFigure, {
        duration: 0.5,
        enableScrollSpy: true,
        scrollSpyOnce: true,
      });
    });
  },

  initProgressBar() {
    const processScroll = () => {
      const docElem = document.documentElement,
        docBody = document.body,
        scrollTop = docElem['scrollTop'] || docBody['scrollTop'],
        scrollBottom =
          (docElem['scrollHeight'] || docBody['scrollHeight']) -
          window.innerHeight,
        scrollPercent = (scrollTop / scrollBottom) * 100 + '%';
      if (document.getElementById('progress-bar')) {
        document
          .getElementById('progress-bar')
          .style.setProperty('--scrollAmount', scrollPercent);
      }
    };
    document.addEventListener('scroll', processScroll);
  },

  initOverlayScroll() {
    const targetElements = document.querySelectorAll(
      '.scrollToElementOverlayTarget'
    );
    const buttonTriggers = document.querySelectorAll(
      '.scrollToElementOverlayTrigger'
    );

    if (buttonTriggers && targetElements) {
      let i = 0;
      Array.from(buttonTriggers).forEach((el) => {
        if (el.classList.contains(`scrollToElementOverlayTrigger${i}`)) {
          const targetElem = document.querySelector(
            `.scrollToElementOverlayTarget${i}`
          );
          // const formElementOffset = targetElem ? targetElem.offsetTop : 0;
          const overlay = document.querySelector(`.overlay-${i}`);
          el.addEventListener('click', () => {
            overlay.scrollTo({ top: targetElem.offsetTop, behavior: 'smooth' });
          });
        }
        i++;
      });
    }
  },

  initPageTopicsPanel() {
    const pageTopicsTriggerEl = document.querySelector(
      '.page-content__navigation > div'
    );

    if (!pageTopicsTriggerEl) return;
    const pageTopicsNavUl = document.querySelector(
      '.page-content__navigation ul'
    );
    const pageTopicsNavUlHeight = pageTopicsNavUl
      ? pageTopicsNavUl.clientHeight
      : 0;

    pageTopicsTriggerEl.addEventListener('click', this.togglePageTopicsPanel);

    pageTopicsNavUl.addEventListener('click', (event) => {});

    document.addEventListener('click', (event) => {
      const isClickedInside =
        pageTopicsTriggerEl.contains(event.target) ||
        pageTopicsNavEl.contains(event.target);
      if (!isClickedInside) {
        const pageTopicsParentEl = document.querySelector(
          '.page-content__nav-wrapper'
        );
        pageTopicsParentEl.classList.remove('open');
      }
    });

    const pageTopicsNavEl = document.querySelector('.page-content__navigation');
  },

  togglePageTopicsPanel: () => {
    const pageTopicsParentEl = document.querySelector(
      '.page-content__nav-wrapper'
    );
    pageTopicsParentEl.classList.toggle('open');
  },

  async initPageScrollIntoView() {
    
    await wait(1000);
    const navParentEl = document.querySelector('.page-content__nav-wrapper');
    if (navParentEl) {
      navParentEl.classList.remove('hidden');
    }
    const targetElements = document.querySelectorAll(
      '.section-page-content .container > .guttenberg-content h2'
    );
    const triggerElementsWrapper = document.querySelector(
      '.page-content__navigation ul'
    );

    const navEl = document.getElementById('site-nav');
    const navHeight = navEl ? navEl.clientHeight : 0;

    const headerEl = document.querySelector('.section-header');
    const headerHeight = headerEl ? headerEl.clientHeight : 0;

    const wpBar = document.getElementById('wpadminbar');
    const wpBarHeight = wpBar ? wpBar.clientHeight : 0;

    if (targetElements) {
      let i = 0;
      Array.from(targetElements).forEach((el) => {
        el.classList.add('scrollToElementTarget');
        el.classList.add('scrollToElementTarget' + i);
        const targetElementContent = el.textContent;
        if (triggerElementsWrapper) {
          const triggerChildElWrapper = document.createElement('li');
          const triggerChildEl = document.createElement('button');
          triggerChildElWrapper.append(triggerChildEl);
          triggerChildEl.classList.add('scrollToElementButtonTrigger');
          triggerChildEl.classList.add('caption');
          triggerChildEl.append(targetElementContent);
          triggerElementsWrapper.appendChild(triggerChildElWrapper);
        }
        i++;
      });
      const triggerElements = document.querySelectorAll(
        '.scrollToElementButtonTrigger'
      );
      i = 0;
      Array.from(triggerElements).forEach((el) => {
        el.classList.add('scrollToElementButtonTrigger' + i);
        if (el.classList.contains(`scrollToElementButtonTrigger${i}`)) {
          const targetElem = document.querySelector(
            `.scrollToElementTarget${i}`
          );
          const targetElementOffset = targetElem ? targetElem.offsetTop : 0;
          el.addEventListener('click', () => {
            window.scrollTo({
              top:
                targetElementOffset +
                headerHeight -
                navHeight -
                wpBarHeight -
                48,
              behavior: 'smooth',
            });

            this.togglePageTopicsPanel();
          });
        }
        i++;
      });
    }
  },

  initImageContentSwipers() {
    // Block (map)
    const imageContentSlidesBlock = document.querySelectorAll(
      '.block-image-content-slides'
    );

    imageContentSlidesBlock.forEach((el, i = 0) => {
      const mainSwiperEl = el.querySelector('.image-content-slides__main');
      const thumbsSwiperEl = el.querySelector('.image-content-slides__thumbs');
      const mainSwiperClass = 'image-content-slides__main' + i;
      const thumbsSwiperClass = 'image-content-slides__thumbs' + i;

      mainSwiperEl.classList.add(mainSwiperClass);
      if (thumbsSwiperEl) {
        thumbsSwiperEl.classList.add(thumbsSwiperClass);
      }

      const thumbsSwiper = new Swiper('.' + thumbsSwiperClass, {
        modules: [Thumbs, Navigation],
        loop: true,
        slidesPerView: 1,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.swiper-thumbs-button.swiper-button-next',
          prevEl: '.swiper-thumbs-button.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: '4',
            spaceBetween: 24,
          },
        },
      });

      const mainSwiper = new Swiper('.' + mainSwiperClass, {
        modules: [Thumbs, Navigation, EffectFade],
        loop: true,
        allowTouchMove: false,
        // spaceBetween: 48,
        autoHeight: true,
        slideToClickedSlide: true,
        thumbs: {
          swiper: thumbsSwiper,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: '.' + mainSwiperClass + ' .swiper-button-next',
          prevEl: '.' + mainSwiperClass + ' .swiper-button-prev',
        },
        breakpoints: {
          1440: {
            autoHeight: false, // Needs to refresh to see
          },
        },
      });
    });
  },

  initBoxImageGalleryBlockSwipers() {
    // Block
    const imageGalleryBlocks = document.querySelectorAll('.box-slide');
    imageGalleryBlocks.forEach((el, i = 0) => {
      const mainSwiperEl = el.querySelector('.box-slide-image-gallery__main');
      const thumbsSwiperEl = el.querySelector(
        '.box-slide-image-gallery__thumbs'
      );
      const thumbsSwiperNavWrapperEl = el.querySelector(
        '.box-slide-image-gallery__thumbs-nav-wrapper'
      );

      const mainSwiperClass = 'box-slide-image-gallery__main' + i;
      const thumbsSwiperClass = 'box-slide-image-galery__thumbs' + i;
      const thumbsSwiperNavWrapperClass =
        'box-slide-image-gallery__thumbs-nav-wrapper' + i;

      if (mainSwiperEl) {
        mainSwiperEl.classList.add(mainSwiperClass);
      }
      if (thumbsSwiperEl) {
        thumbsSwiperEl.classList.add(thumbsSwiperClass);
      }
      if (thumbsSwiperNavWrapperEl) {
        thumbsSwiperNavWrapperEl.classList.add(thumbsSwiperNavWrapperClass);
      }

      const thumbsSwiper = new Swiper('.' + thumbsSwiperClass, {
        modules: [Thumbs, Navigation],
        loop: true,
        slidesPerView: 2,
        watchSlidesProgress: true,
        navigation: {
          nextEl:
            '.' +
            thumbsSwiperNavWrapperClass +
            ' .swiper-thumbs-button.swiper-button-next',
          prevEl:
            '.' +
            thumbsSwiperNavWrapperClass +
            ' .swiper-thumbs-button.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: '4',
          },
        },
      });

      const mainSwiper = new Swiper('.' + mainSwiperClass, {
        modules: [Thumbs, Navigation],
        loop: true,
        slideToClickedSlide: true,
        thumbs: {
          swiper: thumbsSwiper,
        },
      });
    });
  },

  initImageGalleryBlockSwipers() {
    // Block
    const imageGalleryBlocks = document.querySelectorAll(
      '.block-image-gallery'
    );

    imageGalleryBlocks.forEach((el, i = 0) => {
      const mainSwiperEl = el.querySelector('.image-gallery__main');
      const thumbsSwiperEl = el.querySelector('.image-gallery__thumbs');
      const thumbsSwiperNavWrapperEl = el.querySelector(
        '.image-gallery__thumbs-nav-wrapper'
      );

      const mainSwiperClass = 'image-galery__main' + i;
      const thumbsSwiperClass = 'image-galery__thumbs' + i;
      const thumbsSwiperNavWrapperClass =
        'image-gallery__thumbs-nav-wrapper' + i;

      mainSwiperEl.classList.add(mainSwiperClass);
      thumbsSwiperEl.classList.add(thumbsSwiperClass);
      thumbsSwiperNavWrapperEl.classList.add(thumbsSwiperNavWrapperClass);

      const thumbsSwiper = new Swiper('.' + thumbsSwiperClass, {
        modules: [Thumbs, Navigation],
        loop: true,
        slidesPerView: 2,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.' + thumbsSwiperNavWrapperClass + ' .swiper-button-next',
          prevEl: '.' + thumbsSwiperNavWrapperClass + ' .swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: '4',
          },
        },
      });

      const mainSwiper = new Swiper('.' + mainSwiperClass, {
        modules: [Thumbs, Navigation],
        loop: true,
        spaceBetween: 24,
        slideToClickedSlide: true,
        thumbs: {
          swiper: thumbsSwiper,
        },
        navigation: {
          nextEl: '.' + mainSwiperClass + ' .swiper-button-next',
          prevEl: '.' + mainSwiperClass + ' .swiper-button-prev',
        },
      });
    });
  },

  initBoxSlideGalleryBlockSwipers() {
    // Block
    const boxSlideBlocks = document.querySelectorAll('.box-slides-gallery');

    boxSlideBlocks.forEach((el, i = 0) => {
      const swiperClass = 'box-slides-gallery' + i;
      el.classList.add(swiperClass);

      new Swiper('.' + swiperClass, {
        modules: [Navigation],
        slideToClickedSlide: false,
        slidesPerView: '1',
        spaceBetween: 24,
        navigation: {
          nextEl: '.' + swiperClass + ' .swiper-button-next.swiper-main-button',
          prevEl: '.' + swiperClass + ' .swiper-button-prev.swiper-main-button',
        },
        breakpoints: {
          768: {
            slidesPerView: '2',
          },
        },
      });
    });
  },

  initBoxSlideBlockSwipers() {
    // Block
    const boxSlideBlocks = document.querySelectorAll('.box-slides-original');

    boxSlideBlocks.forEach((el, i = 0) => {
      const swiperClass = 'box-slides-original' + i;
      el.classList.add(swiperClass);

      new Swiper('.' + swiperClass, {
        modules: [Navigation],
        slideToClickedSlide: false,
        slidesPerView: '1',
        spaceBetween: 24,
        navigation: {
          nextEl: '.' + swiperClass + ' .swiper-button-next',
          prevEl: '.' + swiperClass + ' .swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: '2',
          },
        },
      });
    });
  },

  initThemeOverlay() {
    const themeOverlayTrigger = document.querySelectorAll(
      '[data-theme-overlay]'
    );
    const themeOverlays = document.querySelectorAll('.overlay-section');

    const toggleOverlay = (event) => {
      event.preventDefault();
      const dataTheme = event.currentTarget.getAttribute('data-theme-overlay');
      const themeOverlay = document.querySelector('.overlay-' + dataTheme + '');

      const themeOverlayContainer = themeOverlay.querySelector('.overlay');

      themeOverlays.forEach((el) => {
        el.classList.add('hidden');
        const themeOverlayCloseButton = el.querySelector('.overlay__close');
        const themeOverlayBackdrop = el.querySelector('.overlay-backdrop');
        themeOverlayCloseButton.addEventListener('click', closeOverlay, {
          capture: true,
        });
        themeOverlayBackdrop.addEventListener('click', closeOverlay, {
          capture: true,
        });
      });

      if (themeOverlay.classList.contains('hidden')) {
        themeOverlay.classList.remove('hidden');
        themeOverlayContainer.scrollTop = 0;
      }
      const html = document.documentElement;
      const overlayOpen = html.classList.contains('overlay-open');
      if (overlayOpen) {
        return;
      } else {
        html.classList.add('overlay-open');
      }
    };

    const closeOverlay = (event) => {
      const { parentNode } = event.currentTarget;
      parentNode.classList.add('hidden');
      toggleOverlayOpenClass();
    };

    const toggleOverlayOpenClass = (event) => {
      const html = document.documentElement;
      const overlayOpen = html.classList.contains('overlay-open');
      if (overlayOpen) {
        html.classList.remove('overlay-open');
      } else {
        html.classList.add('overlay-open');
      }
    };

    themeOverlayTrigger.forEach((el) => {
      el.addEventListener('click', toggleOverlay, { capture: true });
    });
  },

  // initVideoSlideWatchers() {
  //   const els = document.querySelectorAll('[data-video-link]');
  //   Array.from(els).forEach(el => {
  //     const link = el.getAttribute('data-video-link');
  //     if (link) {
  //       el.addEventListener('click', this.playVideo(link));
  //     }
  //   })
  // },

  async initScrollIntoView() {
    await wait(1000);
    // TODO: Make it many triggers for 1 targets it is it only allows 1 trigger to 1 target

    const formElements = document.querySelectorAll(
      '.scrollToElementFormTarget'
    );
    const buttonTriggers = document.querySelectorAll(
      '.scrollToElementButtonTrigger'
    );

    const navEl = document.getElementById('site-nav');
    const navHeight = navEl ? navEl.clientHeight : 0;

    if (buttonTriggers && formElements) {
      let i = 0;
      Array.from(buttonTriggers).forEach((el) => {
        if (el.classList.contains(`scrollToElementButtonTrigger${i}`)) {
          const targetElem = document.querySelector(
            `.scrollToElementFormTarget${i}`
          );
          const formElementOffset = targetElem ? targetElem.offsetTop : 0;

          el.addEventListener('click', () => {
            // window.scrollTo({top: formElementOffset - navHeight - 96 , behavior: "smooth"});
            window.scrollTo({
              top: formElementOffset - navHeight,
              behavior: 'smooth',
            });
          });
        }
        i++;
      });
    }
  },

  initHeroSwiper() {
    const heroSwiper = new Swiper('.hero__slides', {
      modules: [Autoplay, EffectFade],
      allowTouchMove: false,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 5000,
      autoplay: {
        delay: 2500,
      },
      on: {
        slideChangeTransitionStart: function (swiper) {
          const currentSlide = swiper.slides[swiper.activeIndex];
          const currentSlideVideoEl =
            currentSlide?.querySelector('.hero__video');
          const videoEl = currentSlideVideoEl;
          if (!videoEl) return;
          videoEl.pause();
          videoEl.currentTime = 0;
          const isPlaying =
            videoEl.currentTime > 0 &&
            !videoEl.paused &&
            !videoEl.ended &&
            videoEl.readyState > videoEl.HAVE_CURRENT_DATA;
          if (!isPlaying) {
            try {
              videoEl.play();
              // await videoEl.play();
              videoEl.play();
            } catch (error) {
              console.warn(error);
            }
          }
        },
      },
    });
  },

  // initGallerySlides() {
  //   new Swiper('.gallery-slides', {
  //     modules: [ Autoplay ],
  //     slidesPerView: 2,
  //     centeredSlides: true,
  //     loop: true,
  //     speed: 2500,
  //     autoplay: {
  //       delay: 5000,
  //       disableOnInteraction: true,
  //     },
  //     breakpoints: {
  //       320: {
  //         slidesPerView: 1,
  //       },
  //       640: {
  //         // spaceBetween: 96,
  //         slidesPerView: 2,
  //         // spaceBetween: 40
  //       },
  //       // 1024: {
  //       //   spaceBetween: 96,
  //       //   slidesPerView: 3.5,
  //       // },
  //       // 1280: {
  //       //   spaceBetween: 96,
  //       //   slidesPerView: 5,
  //       // }
  //     }
  //     // centeredSlidesBounds: true,
  //   });
  // },

  // initTimelineSwiper() {
  //   new Swiper('.timeline__swiper',  {
  //     modules: [ Autoplay, Navigation ],
  //     slidesPerView: 1,
  //     navigation: {
  //       nextEl: ".timeline__swiper__button--next",
  //       prevEl: ".timeline__swiper__button--prev",
  //       // nextEl: ".swiper-button-next",
  //       // prevEl: ".swiper-button-prev",
  //     },
  //     // loop: true,
  //     // spaceBetween: 48,
  //      // loopedSlides: 2,
  //     //  speed: 5000,
  //     // //  allowTouchMove: false,
  //     //  autoplay: {
  //     //    // delay: 5000,
  //     //    delay: 0,
  //     //    // disableOnInteraction: true,
  //     //  },
  //     breakpoints: {
  //       // when window width is >= 320px
  //       // 320: {
  //       //   slidesPerView: 2,
  //       //   // spaceBetween: 48
  //       // },
  //       // 375: {
  //       //   slidesPerView: 2,
  //       //   spaceBetween: 48
  //       // },
  //       // // when window width is >= 480px
  //       // 480: {
  //       //   slidesPerView: 3,
  //       //   spaceBetween: 30
  //       // },
  //       // // when window width is >= 640px
  //       640: {
  //         // spaceBetween: 96,
  //         slidesPerView: 3,
  //         // slidesPerView: 4,
  //         // spaceBetween: 40
  //       },
  //       1024: {
  //         // spaceBetween: 96,
  //         slidesPerView:4,
  //         // slidesPerView: 4,
  //         // spaceBetween: 40
  //       },
  //       // 1024: {
  //       //   // spaceBetween: 96,
  //       //   slidesPerView: 3.5,
  //       // },
  //       // 1280: {
  //       //   // spaceBetween: 96,
  //       //   slidesPerView: 5,
  //       // }
  //     }
  //   });
  // },

  recordWpAdminBarHeight() {
    const el = document.getElementById('wpadminbar');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--wp-admin-bar-height', height + 'px');
    return height;
  },

  recordNavBarHeight() {
    const el = document.querySelector('.nav');
    // const el = document.querySelector('.section-nav');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--nav-height', height + 'px');
    return height;
  },

  recordMapBarHeight() {
    const el = document.querySelector('.image-content-slides__thumbs');
    // const el = document.querySelector('.section-nav');
    const height = el ? el.clientHeight : 0;
    setCSSCustomProperty('--map-bar-height', height + 'px');
    return height;
  },

  initMeasurementCheckers() {
    const handleWindowLoad = () => {
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      this.recordMapBarHeight();
      // this.updateChartLegendPosition();
    };
    const handleWindowResize = () => {
      this.recordWpAdminBarHeight();
      this.recordNavBarHeight();
      this.recordMapBarHeight();
      // this.updateChartLegendPosition();
    };
    window.addEventListener('load', handleWindowLoad);
    window.addEventListener('resize', handleWindowResize);
  },

  initMeasurementCheckersHome() {
    const handleWindowLoad = () => {
      this.initScrollIntoView();
    };
    const handleWindowResize = () => {
      this.initScrollIntoView();
    };
    window.addEventListener('load', handleWindowLoad);
    window.addEventListener('resize', handleWindowResize);
  },

  // detectRatio(el) {
  //   if (!el) return;
  //   const w = el.clientWidth;
  //   const h = el.clientHeight;
  //   const ratio = w / h;
  //   const orientation = ratio >= 1 ? 'landscape' : 'portrait';
  //   el.setAttribute('data-element-width', w + 'px');
  //   el.setAttribute('data-element-height', h + 'px');
  //   el.setAttribute('data-element-ratio', ratio);
  //   el.setAttribute('data-element-orientation', orientation);
  //   setCSSCustomProperty('--element-width', w + 'px', el);
  //   setCSSCustomProperty('--element-height', h + 'px', el);
  //   setCSSCustomProperty('--element-ratio', ratio, el);
  //   setCSSCustomProperty('--element-orientation', orientation, el);
  // },

  // initRatioWatcher() {
  //   const els = document.querySelectorAll('[data-watch-ratio]');
  //   Array.from(els).forEach(el => {
  //     const handler = () => this.detectRatio(el);
  //     window.addEventListener('load', handler);
  //     window.addEventListener('resize', handler);
  //   });
  // },
};
